import datepicker from 'js-datepicker'
export default class DefaultAction {
  run() {
    this.removeLoading()
    this.runDatepicker()
    this.runPopupJS()
    this.activeTooltip()
    this.focusOutSelectIfChat()
    this.hidePopupFilter()
    this.hidePopupSort()
    this.closePopupSettingMember()
    this.hideSideBar()
    this.hideProjectSideBar()
  }

  runDatepicker() {
    const defaultAction = this
    var current_date = new Date();
    $('.js-datepicker').each(function() {
      if(!$(this).data("datepicker")) {
        const input = this
        const $input = $(this)
        const isCopyTaskModal = $input.closest('.copy-task-modal').length > 0
        let dateSelected = $(this).val() ? new Date($(this).val()) : ''
        let position = $(this).data('datepicker-position') || 'bl'
        $(this).data('datepicker', true)
        datepicker(this, {
          customDays: I18n.t('shared.customDays'),
          customMonths: I18n.t('shared.customMonths'),
          position: position,
          formatter: (input, date, _) => input.value = moment(date).format('Y/MM/DD'),
          dateSelected: dateSelected,
          onShow: (instance) => {
            if (window.innerWidth <= 767 && isCopyTaskModal) {
              defaultAction.floatCopyTaskDatepicker(input, instance)
            }
          },
          onHide: (instance) => {
            if (window.innerWidth <= 767 && isCopyTaskModal) {
              defaultAction.resetCopyTaskDatepicker(instance)
            }
          },
          onSelect: (dateText) => {
            $(this).trigger('change');
          }
        })
      }
    });
    $('.js-datepicker-pc').each(function() {
      if(!$(this).data("datepicker")) {
        const input = this
        const $input = $(this)
        const isCopyTaskModal = $input.closest('.copy-task-modal').length > 0
        let dateSelected = $(this).val() ? new Date($(this).val()) : ''
        let position = $(this).data('datepicker-position') || 'bl'
        $(this).data('datepicker', true)
        datepicker(this, {
          customDays: I18n.t('shared.customDays'),
          customMonths: I18n.t('shared.customMonths'),
          position: position,
          formatter: (input, date, _) => input.value = moment(date).format('Y/MM/DD'),
          dateSelected: dateSelected,
          onShow: (instance) => {
            if (window.innerWidth <= 767 && isCopyTaskModal) {
              defaultAction.floatCopyTaskDatepicker(input, instance)
            }
          },
          onHide: (instance) => {
            if (window.innerWidth <= 767 && isCopyTaskModal) {
              defaultAction.resetCopyTaskDatepicker(instance)
            }
          },
          onSelect: (dateText) => {
            $(this).trigger('change');
          }
        })
      }
    });
    $('.campaign-datepicker').each(function() {
      if(!$(this).data("datepicker")) {
        let dateSelected = $(this).val() ? new Date($(this).val()) : ''
        let position = $(this).data('datepicker-position') || 'bl'
        $(this).data('datepicker', true)
        datepicker(this, {
          customDays: I18n.t('shared.customDays'),
          customMonths: I18n.t('shared.customMonths'),
          position: position,
          formatter: (input, date, _) => input.value = moment(date).format('Y/MM/DD'),
          dateSelected: dateSelected,
          maxDate: new Date(current_date.setDate(current_date.getDate() + 365)),
          onSelect: (dateText) => {
            $(this).trigger('change');
          }
        })
      }
    })
  }

  floatCopyTaskDatepicker(input, instance) {
    const container = $(instance.calendarContainer)
    const originalParent = instance.parent
    container.data('copy-task-original-parent', originalParent)

    if (!container.parent().is('body')) {
      $('body').append(container)
    }

    container.addClass('copy-task-datepicker-floating')

    const inputRect = input.getBoundingClientRect()
    const containerWidth = container.outerWidth() || 288
    const containerHeight = container.outerHeight() || 320
    const viewportWidth = window.innerWidth
    const left = Math.min(Math.max(12, inputRect.left), viewportWidth - containerWidth - 12)
    const top = Math.max(12, inputRect.top - containerHeight - 8)

    container.css({
      top: `${top}px`,
      left: `${left}px`
    })
  }

  resetCopyTaskDatepicker(instance) {
    const container = $(instance.calendarContainer)
    const originalParent = container.data('copy-task-original-parent')
    container.removeClass('copy-task-datepicker-floating').removeAttr('style')
    if (originalParent && container.parent()[0] !== originalParent) {
      $(originalParent).append(container)
    }
  }

  activeTooltip() {
    const listTooltips = [{
      theme: 'light',
      className: 'bg-light border unset--max-width'
    }]
    $(`[data-toggle="tooltip"]:not([data-theme])`).tooltip()
    listTooltips.forEach(ele => {
      $(`[data-toggle="tooltip"][data-theme="${ele.theme}"]`).tooltip({
        template: this._tooltipTemplate(ele.className)
      });
    })
  }

  _tooltipTemplate(className) {
    return `<div class="tooltip" role="tooltip">
              <div class="tooltip-inner ${className}"></div>
            </div>`
  }

  removeLoading() {
    $('.preloader').fadeOut();
  }

  runPopupJS() {
    gon.popupJS.forEach(ele => {
      const messages = typeof(ele.message) === 'string' ? ele.message : ele.message.join('<br>')
      Popup.alert(messages, ele.type)
    })
  }

  focusOutSelectIfChat() {
    $('select').on('click', function(e) {
      const listChat = $('.body-chat-area').toArray();
      listChat.forEach(chat => {
        if ($(chat).width() > 500) {
          $(e.target).blur()
          $(chat).focus();
        }
      })
    })
  }

  hidePopupFilter() {
    $(document).on('click', function(e) {
      if ($(e.target).closest('.filter-content.dropdown-new-stype').length > 0) return
      if ($(e.target).closest('.project-search-kind-dropdown').length > 0) return
      if ($(e.target).closest('.qs-datepicker-container').length > 0) return
      if ($(e.target).parents('td.td-filter-box').length > 0) return
      Visiable.hide('.filter-content')
    })
  }

  hidePopupSort() {
    $(document).on('click', function(e) {
      if ($(e.target).closest('.sort_box').length > 0) return
      if ($(e.target).parents('td.td-sort-box').length > 0) return
      Visiable.hide('.sort_box')
    })
  }

  closePopupSettingMember() {
    $(document).on('click', function(e) {
      if ($(e.target).hasClass('dt-paging-button')) return
      if ($(e.target).hasClass('unapprove-label')) return
      if ($(e.target).closest('#tm-confirm-overlay').length > 0) return
      if($('#popupInviteMember').length > 0 && !$('#popupInviteMember').hasClass('d-none')) {
        if ($(e.target).parents('.div-popup-invite-member').length > 0) return
        if ($(e.target).parents('.popup-invite-member').length > 0) return
        if ($(e.target).parents('.new_alert_popup').length > 0) return
        if ($(e.target).parents('.akaire_alert_popup').length > 0) return
        if ($(e.target).hasClass('swal2-backdrop-hide')) return
        if ($(e.target).parents('.swal2-backdrop-show').length > 0) return
        if ($(e.target).parents('.paging_full_numbers').length > 0) return
        if ($(e.target).hasClass('dt-paging-button')) return

        // iPad teleport guard: If .filter-content is moved to document.body, 
        // DOM parent checks won't detect it's inside a popup.
        // We follow _teleportOrigin to verify if the original parent was inside a popup.
        const teleportedFilterContent = e.target.closest('.filter-content');
        if (teleportedFilterContent && teleportedFilterContent._teleportOrigin) {
          const origin = teleportedFilterContent._teleportOrigin;
          if (
            origin.closest('.div-popup-invite-member') ||
            origin.closest('.popup-invite-member')
          ) return;
        }

        if($('#popupInviteMember').is(':visible')) {
          if ($('.button-cancel-update-permission').length) {
            $('.button-cancel-update-permission').click()
          } else {
            Project.hideSettingMemberModal()
          }
        }
      }
    })
  }

  hideSideBar() {
    $('.hidePopupSideBar').on('click', function(e) {
      $('#sidebar-recently').addClass('d-none');
    })
  }

  hideProjectSideBar() {
    $('.hidePopupSideBarProject').on('click', function(e) {
      $('#recently-projects').addClass('d-none');
    })
  }

  showDropdownAkaireFile() {
    $('.dropdown-toggle-akaire-file-header').on('click', function(e) {
      e.preventDefault();
      $(this).next('.dropdown-menu').toggle();
    })
  }
}
